import React from "react";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";

import { Button } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import {
  useNotify,
  useRefresh,
  useTranslate,
  useDataProvider,
} from "react-admin";

import { get } from "lodash";

const IsDefaultField = ({ record, source }) => {
  const refresh = useRefresh();
  const dataProvider = useDataProvider();
  const translate = useTranslate();
  const notify = useNotify();
  const handleClick = () => {
    dataProvider
      .update("bookmaker-landings/change-status", { data: record })
      .then(({ success }) => {
        refresh();
        notify(
          translate("resources.bookmaker-landings.messages.is_default_changed")
        );
      })
      .catch(({ error: { message } }) => notify(message, "warning"));
  };
  const isDefault = get(record, source);
  return (
    <Button
      onClick={handleClick}
      disabled={get(record, source)}
      title={translate("resources.bookmaker-landings.fields.is_default.help")}
    >
      {isDefault ? (
        <CheckBoxIcon style={{ color: green[500] }} />
      ) : (
        <CheckBoxOutlineBlankIcon />
      )}
    </Button>
  );
};
export default IsDefaultField;
